import {
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
  } from "@chakra-ui/react";
  import { useState } from "react";
  import useApi from "hooks/useApi";
  import { showToast } from "components/toast/Toast";
  import { formatDateToUTC } from "constants/commonFunctions";
  import FormExpiryForAll from "./FormExpiryForAll";
  import { UPDATE_EXPIRY_ALL } from "constants/endpoints";
  
  const initialFormData = {
    expires_on: "",
    update_actual_expiry: true
  };
  
  const UpdateExpiryForAll = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState(initialFormData);
    const [isSubmittingForm, setIsSubmittingForm] = useState(false);
    const { apiCall } = useApi();
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      const formattedDate = formatDateToUTC(value);
      setFormData((prev) => ({
        ...prev,
        [name]: formattedDate,
      }));
    };

    const handleCheckboxChange = (e) => {
      const { name, checked } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    };
  
    const handleSubmit = async () => {
      try {
        setIsSubmittingForm(true);
  
        const updatedExpiryDate = { expires_on: formData.expires_on, update_actual_expiry: formData.update_actual_expiry };
        try {
          const url = UPDATE_EXPIRY_ALL;
          const response = await apiCall.patch(url, updatedExpiryDate);
          if (response) {
            showToast({
              message: response.data.message,
              success: true,
              customStyle: {
                background: "#52c41a",
                color: "#fff",
                padding: "10px",
              },
            });
          }
          if (response.data) {
            setIsSubmittingForm(false);
            onClose(); // Close the modal after successful submission
          }
        } catch (error) {
          console.error("Error updating expiry", error);
          throw error?.response?.data?.error?.message
            ? error?.response?.data?.error?.message
            : error?.response?.data?.error;
        }
      } catch (error) {
        console.error("Error submitting expiry date:", error);
        setIsSubmittingForm(false);
        showToast({
          message: error,
          success: false,
          customStyle: {
            background: "#F24052",
            color: "#fff",
            padding: "10px",
          },
        });
      }
    };
  
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Flex direction={{ base: "column", md: "column" }} gap={2}>
              <FormExpiryForAll
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                formData={formData}
                disabled={isSubmittingForm}
                isSubmittingForm={isSubmittingForm}
                handleCheckboxChange={handleCheckboxChange}
              />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  };
  
  export default UpdateExpiryForAll;
  